import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const DiscountContext = createContext()

const DiscountProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllDiscounts = async (filter) => {
        try {
            const { page, search, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/discount?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getSingleDiscount = async (id) => {
        try {

            let { data } = await axios.get(`${baseURL}/admin/discount/${id}`, { headers })

            if (data.error === false) {
                return data.data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })

        }
    }

    const getDiscountClaimDetails = async (id, filter) => {
        try {
            const { page, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/discount/${id}/claims/${page}/${limit}`, { headers })

            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const createDiscount = async (discountDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/discount/create`, discountDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const updateDiscount = async (id, discountDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/discount/update/${id}`, discountDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const updateDiscountActivationStatus = async (id, discountDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/discount/update/activation/status/${id}`, discountDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const deleteDiscount = async (id) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/discount/delete/${id}`, { headers });
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: 'An error occurred. Please try again later.', position: 'top', status: 'error', isClosable: true });
        }
    }

    const getAllCategories = async (filter) => {
        try {
            const { page, search, limit, activeOnly } = filter

            const { data } = await axios.get(`${baseURL}/admin/discount/category?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}&activeOnly=${activeOnly}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const getSingleCategory = async (id) => {
        try {
            const { data } = await axios.get(`${baseURL}/admin/discount/category/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const createCategory = async (categoryDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/discount/category/create`, categoryDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const updateCategory = async (id, categoryDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/discount/category/update/${id}`, categoryDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    const deleteCategory = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/admin/discount/category/delete/${id}`, { headers });
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <DiscountContext.Provider
            value={{
                createDiscount,
                getAllDiscounts,
                getSingleDiscount,
                getDiscountClaimDetails,
                updateDiscount,
                updateDiscountActivationStatus,
                deleteDiscount,
                getAllCategories,
                getSingleCategory,
                createCategory,
                updateCategory,
                deleteCategory
            }}>
            {children}
        </DiscountContext.Provider>
    )
}

const useDiscount = () => useContext(DiscountContext)

export { useDiscount, DiscountProvider }